import { render, staticRenderFns } from "./EVerificadorConflitosAula.vue?vue&type=template&id=28e45b1d&scoped=true"
import script from "./EVerificadorConflitosAula.vue?vue&type=script&lang=js"
export * from "./EVerificadorConflitosAula.vue?vue&type=script&lang=js"
import style0 from "./EVerificadorConflitosAula.vue?vue&type=style&index=0&id=28e45b1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e45b1d",
  null
  
)

export default component.exports